import "./logotype-block.scss";